import styled from "styled-components";
import * as styles from "styles";
import * as Types from "Types";
import { useSelector } from "react-redux";

const Wrap = styled.div<any>`
   display: ${({ count }) => (count > 0 ? "grid" : "none")};
   column-gap: ${({ columnGap }) => columnGap};
   row-gap: ${({ rowGap }) => rowGap};
   margin: ${({ marginVertical }) => marginVertical} ${({ marginHorizontal }) => marginHorizontal};
   grid-template-columns: repeat(${({ count }) => count}, 1fr);
   flex-grow: 1;
   font-size: ${({ count }) => count};
   ${({ css }) => css}
`;

function GridContainer(props: Types.Grid.Container) {
   const width = useSelector(({ dimensions }: Types.State) => dimensions.width);

   const size = styles.getGridSize(width);

   const count = props.count || styles.grid[size].count;
   const columnGap = props.columnGap || styles.grid[size].columnGap;
   const rowGap = props.rowGap || styles.grid[size].rowGap;
   const marginVertical = props.marginVertical || styles.grid[size].marginVertical;
   const marginHorizontal = props.marginHorizontal || styles.grid[size].marginHorizontal;

   return <Wrap {...{ count, columnGap, rowGap, marginVertical, marginHorizontal }}>{props.children}</Wrap>;
}

export default GridContainer;
